/* eslint-disable @typescript-eslint/no-unsafe-assignment -- TODO: Error objects from $fetch typed as unknown/any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access -- TODO: Error shapes vary by HTTP client */
/* eslint-disable @typescript-eslint/no-unsafe-call -- TODO: Error message checking needs type guards */

import { keysToCamel } from '~/utility/toCamel'
import { BookingPaymentStatus, bookingPaymentStatusSchema } from './schema'

export class BookingPaymentStatusServiceFetch {
  async get(
    paymentId: string,
    bookingId: string,
  ): Promise<BookingPaymentStatus> {
    const url = `/_/fallback/booking/payment/${paymentId}/${bookingId}/?ajax`

    try {
      const response = await $fetch(url, {
        timeout: 10000,
      })

      // Check if response is a string and try to parse it
      let parsedResponse = response
      if (typeof response === 'string') {
        try {
          parsedResponse = JSON.parse(response)
        } catch (parseError: unknown) {
          console.error(
            'Failed to parse JSON response for booking payment status',
            {
              error: parseError,
              url,
              status: 200,
              responseType: typeof response,
              responseContent: response,
              paymentId,
              bookingId,
            },
          )
          const errorMessage =
            parseError instanceof Error
              ? parseError.message
              : 'Unknown parse error'
          throw new Error(`Invalid JSON response: ${errorMessage}`)
        }
      }

      // Ensure we have an object before using keysToCamel
      if (typeof parsedResponse !== 'object' || parsedResponse === null) {
        console.error('Invalid response type for booking payment status', {
          url,
          status: 200,
          responseType: typeof parsedResponse,
          responseContent: parsedResponse,
          paymentId,
          bookingId,
        })
        throw new Error(
          `Expected object response, got ${typeof parsedResponse}`,
        )
      }

      const camelCasedResponse = keysToCamel(parsedResponse)

      try {
        return bookingPaymentStatusSchema.parse(camelCasedResponse)
      } catch (zodError: unknown) {
        // Log full details when Zod validation fails
        console.error('Zod validation failed for booking payment status', {
          error: zodError,
          url,
          status: 200,
          responseType: typeof parsedResponse,
          responseContent: camelCasedResponse,
          rawResponse: parsedResponse,
          originalResponse: response,
          paymentId,
          bookingId,
        })
        throw zodError
      }
    } catch (fetchError: unknown) {
      const error = fetchError as any

      // Extract status code from various error formats
      const statusCode =
        error?.status ||
        error?.statusCode ||
        error?.data?.statusCode ||
        error?.response?.status ||
        error?.statusCode

      // Check if it's a 404 error
      if (statusCode === 404) {
        console.error('Booking payment status not found (404)', {
          error: fetchError,
          url,
          paymentId,
          bookingId,
          statusCode,
        })
        // Throw a specific error for 404
        const notFoundError = new Error('Booking payment status not found')
        ;(notFoundError as any).statusCode = 404
        ;(notFoundError as any).originalError = fetchError
        throw notFoundError
      }

      // Check for timeout errors
      const isTimeout =
        error?.message?.toLowerCase().includes('timeout') ||
        error?.code === 'ECONNABORTED' ||
        error?.code === 'ETIMEDOUT'

      // Log other fetch errors with full context
      const errorDetails = {
        message: error?.message || 'Unknown error',
        statusCode,
        url,
        paymentId,
        bookingId,
        errorType: error?.name || 'FetchError',
        isTimeout,
        stack: error?.stack,
      }

      console.error('Failed to fetch booking payment status', errorDetails)

      // Enhance the error with additional context before rethrowing
      if (fetchError instanceof Error) {
        ;(fetchError as any).context = errorDetails
      }

      throw fetchError
    }
  }
}
